import { useEffect, useRef } from 'react';

export default function LoadMoreSentinel({
  onVisible,
}: {
  onVisible: () => void;
}) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          console.log('LoadMoreSentinel onVisible');
          onVisible();
        }
      },
      { root: null, rootMargin: '0px 0px 300px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [onVisible]);

  return <div ref={ref} />;
}
